import TextField from "@material-ui/core/TextField";
import { Language, Email } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";

function TabComerzzia({ values, touched, errors, handleChange }) {
  console.log(values);

  return (
    <ModernFormContainer>
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#3498db">
              <Language />
            </SectionIcon>
            <SectionTitle>Configurações Comerzzia</SectionTitle>
          </SectionHeader>
          <FormGrid columns={2}>
            <StyledFieldContainer>
              <FieldLabel>
                <Language style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
                URL Comerzzia
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="comerzzia_url"
                name="comerzzia_url"
                placeholder="https://comerzzia.example.com"
                value={values.comerzzia_url}
                onChange={handleChange}
                error={touched.comerzzia_url && Boolean(errors.comerzzia_url)}
                helperText={touched.comerzzia_url && errors.comerzzia_url}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <Email style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
                E-mail de notificação
              </FieldLabel>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="notification_email"
                name="notification_email"
                placeholder="email1@example.com,email2@example.com"
                value={values.notification_email}
                onChange={handleChange}
                error={touched.notification_email && Boolean(errors.notification_email)}
                helperText={touched.notification_email && errors.notification_email}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
          </FormGrid>

          <FormGrid columns={1} style={{ marginTop: '20px' }}>
            <CheckboxContainer>
              <CheckboxWrapper onClick={() => handleChange({ target: { name: 'validate_pos', type: 'checkbox', checked: !values.validate_pos } })}>
                <StyledCheckbox checked={values.validate_pos || false}>
                  {values.validate_pos && <CheckIcon>✓</CheckIcon>}
                </StyledCheckbox>
                <CheckboxLabel>
                  Validar POS
                  <CheckboxDescription>
                    Ativa a validação de POS durante o processamento
                  </CheckboxDescription>
                </CheckboxLabel>
              </CheckboxWrapper>
            </CheckboxContainer>
          </FormGrid>
        </SectionCard>
      )}
    </ModernFormContainer>
  );
}

export default TabComerzzia;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#667eea15'};
  color: ${props => props.color || '#667eea'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${SectionCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  padding: 16px;
  border-radius: 12px;
  background: #f8f9fa;
  border: 2px solid #e5e7eb;
  transition: all 0.3s ease;
  user-select: none;

  &:hover {
    background: #f1f3f5;
    border-color: #9b59b6;
    box-shadow: 0 2px 8px rgba(155, 89, 182, 0.1);
  }
`;

const StyledCheckbox = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 6px;
  border: 2px solid ${props => props.checked ? '#9b59b6' : '#cbd5e1'};
  background: ${props => props.checked ? '#9b59b6' : 'white'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  margin-right: 12px;

  ${CheckboxWrapper}:hover & {
    border-color: #9b59b6;
    transform: scale(1.1);
  }
`;

const CheckIcon = styled.span`
  color: white;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
`;

const CheckboxLabel = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Mulish', sans-serif;
  flex: 1;
`;

const CheckboxDescription = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #6b7280;
  margin-top: 4px;
  display: block;
`;
